import loadRoute from 'launch/components/loadRoute';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

interface Match {
    url: string;
}

interface Props {
    match: Match;
    location: Object;
}

class LogoBrandGuide extends React.Component<Props> {
    render() {
        return (
            <Switch>
                <Route
                    path={`${this.props.match.url}/designs`}
                    component={loadRoute(
                        (done: any) => require(['launch/components/BriefStyleSelector'], done),
                        {
                            withStyleAssessment: true,
                        }
                    )}
                />
                <Route
                    path={`${this.props.match.url}/attributes`}
                    component={loadRoute(
                        (done: any) => require(['launch/components/BriefStyleAttributes'], done),
                        {}
                    )}
                />
                <Route
                    path={`${this.props.match.url}/colors`}
                    component={loadRoute(
                        (done: any) => require(['launch/components/BriefStyleColors'], done),
                        {}
                    )}
                />
                <Route
                    path={`${this.props.match.url}/brief`}
                    component={loadRoute(
                        (done: any) => require(['launch/components/LogoBrandGuideBrief'], done),
                        {}
                    )}
                />
                <Redirect
                    from="*"
                    to={{ ...this.props.location, pathname: `${this.props.match.url}/designs` }}
                />
            </Switch>
        );
    }
}

export default LogoBrandGuide;
